export default "__VITE_ASSET__BJUr0otK__"